module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/is-nan.js
// module id = 156
// module chunks = 168707334958949